<template>
  <div class="container">
    <div class="weui-msg">
        <div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">支付失败</h2>
            <p class="weui-msg__desc">转账支付失败，请确认银行信息后重新尝试。如果银行卡已经扣款，请速联系我们客服进行退款</p>
        </div>
        <div class="btn-box">
          <div class="btn active" @click="payOrder()">重新支付</div><br>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order-failed',
  methods: {
    payOrder(){
      history.replaceState(null, null, '/#/order');
      this.goto('/order-detail?id='+this.$route.query.id);
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:30px;
}

.container /deep/{
  .weui-icon-success{
    color:#fe9567;
  }
  .weui-btn_primary{
    background:#fe9567;
    color:#fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/order/order-error-poli.vue